site.labelFocus = {
	init: function () {
		if ($('body').is('admin')) return false;

		var $form = $('form');
		if ($form.length) {
			$form.find('input[type="text"], input[type="password"], textarea').on('blur keyup change click', function () {
				if ($(this).val() === '' && !$(this).is(':focus')) {
					$(this).parents('.elm').removeClass('focus');
				}
				else {
					$(this).parents('.elm').addClass('focus');
				}
			}).on('focus', function () {
				$(this).parents('.elm').addClass('focus');
			}).each(function() {
				if ($(this).attr('value') !== '' && !$(this).is(':focus')) {
					$(this).parents('.elm').addClass('focus');
				}
			});
		}
	}
};

 site.inits.push('site.labelFocus.init()');
